import { render, staticRenderFns } from "./modal-mdf-name.vue?vue&type=template&id=3d21d5a4&scoped=true&"
import script from "./modal-mdf-name.vue?vue&type=script&lang=js&"
export * from "./modal-mdf-name.vue?vue&type=script&lang=js&"
import style0 from "./modal-mdf-name.vue?vue&type=style&index=0&id=3d21d5a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d21d5a4",
  null
  
)

export default component.exports